import type { IQuestionsPageViewProps } from '../QuestionsPageView';
import type { MajorSchemaType } from '../stepsMap';

import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';

import { QuestionPageContext } from '../QuestionPageProvider';
import { majorSchema } from '../stepsMap';

import StudentQuestion from '$/components/blocks/StudentQuestion';
import BorderBottomSpan from '$/components/elements/BorderBottomSpan';
import Container from '$/components/elements/Container';
import AutocompleteInputQuestion from '$/components/elements/Questions/AutocompleteInputQuestion';
import { H4Typography } from '$/components/elements/Typography';
import * as queries from '$/graphql/queries';
import { TRACKING_ACTION } from '$/utils/tracking/consts';

const Major = ({ mostPopularSpecializations }: IQuestionsPageViewProps) => {
  const { setCurrentStep, dispatch, state } = useContext(QuestionPageContext);

  const { control, handleSubmit } = useForm<MajorSchemaType>({
    mode: 'onChange',
    resolver: yupResolver(majorSchema),
    defaultValues: state,
  });

  const onSubmit = ({ major }: MajorSchemaType) => {
    if (major?.[0]) {
      if (
        mostPopularSpecializations.find((a) => a.id === major?.[0].id) ||
        major?.[0].subjectId
      ) {
        dispatch({
          type: 'set',
          payload: {
            major,
            field: [
              {
                id: major?.[0].subjectId,
                value: major?.[0].subjectId.toString(),
              },
            ],
          },
        });

        setCurrentStep('city');
      } else {
        dispatch({
          type: 'set',
          payload: {
            major,
          },
        });

        setCurrentStep('field');
      }
    }
  };

  return (
    <StudentQuestion noLimitHeight>
      <StudentQuestion.Section>
        <Container>
          <H4Typography bold as="h1" color="grey7">
            <span>Nun ein paar Fragen zu </span>
            <BorderBottomSpan>deinem Studium.</BorderBottomSpan>
          </H4Typography>
        </Container>
      </StudentQuestion.Section>
      <Container as="form" onSubmit={handleSubmit(onSubmit)}>
        <AutocompleteInputQuestion
          control={control}
          name={'major'}
          title={'Wähle dein Studienfach.'}
          placeholder={'Suche dein Studienfach'}
          query={queries.specializationAutoComplete}
          list={mostPopularSpecializations}
          maxElements={10}
          onValueSelected={handleSubmit(onSubmit)}
          selectFieldElbAction={TRACKING_ACTION.REGISTRATION.MAJOR_YES}
          searchedFieldElbAction={TRACKING_ACTION.REGISTRATION.MAJOR_NO}
        />
      </Container>
    </StudentQuestion>
  );
};

export default Major;
